import { Component, inject } from '@angular/core';
import { ToastService } from './toast.service';

@Component({
  selector: 'ks-toast-container',
  standalone: false,
  templateUrl: './toast-container.component.html',
  styleUrl: './toast-container.component.scss',
})
export class ToastContainerComponent {
  readonly svc = inject(ToastService);
}
